export const CARE_TEAM_LOADED_SUCCESS = 'CARE_TEAM_LOADED_SUCCESS';
export const CARE_TEAM_LOADED_FAILURE = 'CARE_TEAM_LOADED_FAILURE';
